import { merge, type LocaleModules } from './index';

export const wizardDE = merge(import.meta.glob('./*.de.ts', { eager: true }) as LocaleModules);
